<template>
    <div class="iframe-page">
        <iframe ref="iframe" style="width: 100%;height: 100%"
                :src="jgIp + src" frameborder="0"
                @load="loaded"></iframe>
    </div>
</template>
<style scoped>
    .iframe-page{
        position: absolute;
        width: 100%;
        height: 100%;
    }
</style>
<script>
    import {mapGetters, mapActions} from 'vuex';
    export default {
        data(){
            return {
                src:'',
                userInfo:{},
                // jgIp: 'http://192.168.115.193:8086/'    // 测试
            };
        },
        computed: {
            ...mapGetters(['jgIp','permissions']),
            // ...mapGetters(['permissions']), // 测试
        },
        props:{

        },
        created(){
            this.src=this.$route.name;
            this.userInfo={
                userId:this.$cookie.get('userId'),
                userName:this.$cookie.get('userName'),
                loginType:this.$cookie.get('loginType'),
                deptName:this.$cookie.get('deptName'),
                tenantAreaCode:this.$cookie.get('tenantAreaCode'),
                creditCode:this.$cookie.get('creditCode'),
                idCardNumber:this.$cookie.get('idCardNumber'),
                jgIp:this.jgIp,
                ...this.permissions,
            };
            // console.log(this.userInfo)
        },
        mounted(){
            // 监听iframe传递的值
            window.addEventListener('message', this.handleMessage);
        },
        watch: {
            '$route' (to, from) {
                // 对路由变化作出响应...
                this.src=to.name;
            }
        },
        methods: {
            loaded(){
                // iframe的window对象
                let iframeWin = this.$refs.iframe.contentWindow;
                // 向 jgIp 发送数据
                iframeWin.postMessage(this.userInfo, this.jgIp);
            },
            handleMessage(e){
                if(e.origin===this.jgIp){
                    // this.$router.push({
                    //     name:'statistics'
                    // })
                }
            },
        }
    };
</script>
